import { colors } from '@akin-home/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import styled from 'styled-components/native';
import { openPhone } from '../../phone/dialNumber/dialNumber';
import DashboardPanel from '../DashboardPanel';

interface Props {
  size?: number;
}

/** App Widget displays an app icon that opens the specified application when clicked */
export const PhoneWidget = ({ size }: Props) => {
  return (
    <Panel>
      <Container onPress={openPhone}>
        <FontAwesomeIcon
          icon={['fad', 'phone']}
          color={colors.success[60]}
          size={size || 75}
        />
      </Container>
    </Panel>
  );
};
const Container = styled.TouchableOpacity`
  flex: 1;
  align-items: center;
  justify-content: center;
`;

const Panel = styled(DashboardPanel)`
  flex: 1;
`;
